var map = {
	"./Accordion.svg": "6fGA",
	"./Breadcrumb.svg": "NXJb",
	"./Button.svg": "JC1X",
	"./Checkbox.svg": "/UAx",
	"./Code snippet.svg": "fblR",
	"./Content switcher.svg": "XWdB",
	"./Data table.svg": "UIRf",
	"./Date picker.svg": "g77u",
	"./Dropdown.svg": "KEw6",
	"./File uploader.svg": "Gp39",
	"./Form.svg": "/dUG",
	"./Inline loading.svg": "NTvI",
	"./Link.svg": "1xHQ",
	"./List.svg": "lSDP",
	"./Loading.svg": "F/lX",
	"./Modal.svg": "KtVC",
	"./Multiselect.svg": "ioou",
	"./NoImage.svg": "nFty",
	"./Notification.svg": "RqMK",
	"./Number input.svg": "Fjr3",
	"./Overflow menu.svg": "IpCR",
	"./Pagination.svg": "a9RV",
	"./Progress indicator.svg": "vgID",
	"./Radio button.svg": "HTrQ",
	"./Search.svg": "zT6t",
	"./Select.svg": "Z4KQ",
	"./Slider.svg": "bS9a",
	"./Structured list.svg": "BOgH",
	"./Tabs.svg": "von4",
	"./Tag.svg": "1M3v",
	"./Text input.svg": "OCe0",
	"./Tile.svg": "DuYh",
	"./Toggle.svg": "kwPr",
	"./Tooltip.svg": "b7yY",
	"./UI shell.svg": "Leq0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YDgK";